import Vue from "vue";
import axios from "axios";
import { apis } from "@/static/js/apis.js";
// import NoData from "@/components/NoData.vue";

//加入token
let Authorization = window.localStorage.getItem("token");
if (Authorization)
  axios.defaults.headers.common["Authorization"] = Authorization;

let myVuePlugin = new Object();
myVuePlugin.install = function(Vue) {
  /**
   *  接口全局化
   * */
  Vue.prototype.apis = apis;
  /**
   *  get 请求
   *  @params String url
   *  @params Object params
   *  @use this.get(url,params:{}).then(fn).catch(fn)
   * */
  Vue.prototype.get = axios.get;
  /**
   *  post 请求
   *  @params String url
   *  @params Object params
   *  @use this.post(url,{}).then(fn).catch(fn)
   * */
  Vue.prototype.post = axios.post;
  /**IndentationError: unindent does not match any outer indentation level
   *  post 请求
   *  @params String url
   *  @params Object params
   *  @use this.post(url,{}).then(fn).catch(fn)
   * */
  Vue.prototype.changeRouter = function(path) {
    this.$router.push({
      path,
    });
  };
  /**
   *  全局无数据组件
   * */
  // Vue.component('NoData', NoData);
  Vue.component("NoData", () => import("@/components/NoData.vue"));
  /**
   *  获取域名和端口
   *  http://ip:port
   * */
  Vue.prototype.host = location.protocol + "//" + window.location.host + "/";
  /**
   *  返回顶部
   * */
  Vue.prototype.scrollTop = function() {
    window.scrollTo(0, 0);
  };
  /**
   *  手机号正则判断
   * */
  Vue.prototype.regularPhone = function(data) {
    let reg = /^(1[3|4|5|7|8])\d{9}$/;
    if (reg.test(data)) {
      return true;
    } else {
      return false;
    }
  };
  /**
   *  获取验证码
   * */
  Vue.prototype.getCode = function(mobile) {
    this.post(this.apis.getIdentifyingCode, { mobile })
      .then((response) => {
        if (response.data.retCode == "SUCCESS") {
          //
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
  /**
   *  获取用户信息
   *  组件中使用此接口的前置条件：
   *    import {  mapMutations } from "vuex";
   *    ...mapMutations(["setUserInfo"]),
   * */
  Vue.prototype.getMemberInfo = function(fn) {
    this.post(this.apis.getMemberInfo, {
      weixinId: this.openIdKey,
    })
      .then((response) => {
        if (response.data.retCode == "SUCCESS") {
          this.setUserInfo(response.data);
          if (fn) {
            fn();
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
};

Vue.use(myVuePlugin);

/**
 *  index 路由守卫精准控制Tab
 *  路由发生变化修改页面title
 *  路由发生变化控制菜单渲染
 * */
const imgSrc = {
  home: require("@/static/images/tab/shouye_nor.png"),
  homeSelect: require("@/static/images/tab/shouye_sel.png"),
  my: require("@/static/images/tab/wode_sel.png"),
  mySelect: require("@/static/images/tab/wode_nor.png"),
  card: require("@/static/images/tab/kaquan_nor.png"),
  cardSelect: require("@/static/images/tab/kaquan_sel.png"),
  order: require("@/static/images/tab/dingdan_nor.png"),
  orderSelect: require("@/static/images/tab/dingdan_sel.png"),
};
const imgUrlObj = (Vue.prototype.imgUrlObj = {
  homeSrc: imgSrc.home,
  mySrc: imgSrc.my,
  cardSrc: imgSrc.card,
  orderSrc: imgSrc.order,
  navItem: "",
});
const routerChangeEvent = (to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  /* 路由发生变化控制菜单渲染 */
  if (to.meta.auth && to.meta.auth == "index") {
    imgUrlObj.homeSrc = imgSrc.homeSelect;
    imgUrlObj.mySrc = imgSrc.my;
    imgUrlObj.cardSrc = imgSrc.card;
    imgUrlObj.orderSrc = imgSrc.order;
    imgUrlObj.navItem = "Home";
  }

  if (to.meta.auth && to.meta.auth == "ticket") {
    imgUrlObj.homeSrc = imgSrc.home;
    imgUrlObj.mySrc = imgSrc.my;
    imgUrlObj.cardSrc = imgSrc.cardSelect;
    imgUrlObj.orderSrc = imgSrc.order;
    imgUrlObj.navItem = "Card";
  }
  if (to.meta.auth && to.meta.auth == "order") {
    imgUrlObj.homeSrc = imgSrc.home;
    imgUrlObj.mySrc = imgSrc.my;
    imgUrlObj.cardSrc = imgSrc.card;
    imgUrlObj.orderSrc = imgSrc.orderSelect;
    imgUrlObj.navItem = "Order";
  }
  if (to.meta.auth && to.meta.auth == "my") {
    imgUrlObj.homeSrc = imgSrc.home;
    imgUrlObj.mySrc = imgSrc.mySelect;
    imgUrlObj.cardSrc = imgSrc.card;
    imgUrlObj.orderSrc = imgSrc.order;
    imgUrlObj.navItem = "My";
  }
  next();
};

export { routerChangeEvent };

export const handleRequestError = (_this, error, callback) => {
  // 处理首页token失效
  const that = _this;
  const path = that.$route.path;
  if (error && error.response) {
    switch (error.response.status) {
      case 401:
        localStorage.clear();
        if (path === "/") {
          callback && callback();
        } else {
          let backlen = that.$route.matched.length-1;
          that.$router.go(-backlen);
          that.$router.push({
            name: "Home",
            params: {
              isRefresh: true,
            },
          });
        }
        break;
    }
  }
};
